import PropTypes from 'prop-types';
import React from 'react';
import S from '../styles.scss';

const EditableTableHeaders = ({ cells, showDelete, showSave }, context) => {
  const headers = cells.filter(c => c.props.display).map(c => (
    <th key={c.props.label} className={S.cell}>{c.props.label}</th>
  ));

  if (context.isEditable && !context.hasCustomControls) {
    if (showDelete) headers.unshift(<th key="deletectrl" className={S.cell} />);
    if (showSave) headers.push(<th key="savectrl" className={S.cell} />);
  }

  return <tr className={S.headerRow}>{headers}</tr>;
};

EditableTableHeaders.contextTypes = {
  isEditable: PropTypes.bool,
  hasCustomControls: PropTypes.bool,
};

EditableTableHeaders.propTypes = {
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      props: PropTypes.shape({
        display: PropTypes.bool,
        label: PropTypes.string,
      }),
    }),
  ).isRequired,
  showDelete: PropTypes.bool.isRequired,
  showSave: PropTypes.bool.isRequired,
};

EditableTableHeaders.defaultProps = {
  cells: [],
};

export default EditableTableHeaders;



// WEBPACK FOOTER //
// ./client/app/shared/components/EditableTable/components/editableTableHeaders.jsx